import { useEffect, useState } from "react";

import { getEmployeeServiceData } from "@api/employeeServiceData";

interface ServiceType {
  dataType: string;
  positionId?: any;
  gradeId?: any;
  // positionId?: string | number;
  unitId?: string | number;
  unitIds?: any;
  empIds?: any;
}

export const useEmployeeServiceData = (service: ServiceType) => {
  const [data, setData] = useState<any>();

  useEffect(() => {
    if (service) {
      getEmployeeServiceData(service)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [service.positionId, service.unitId, service.empIds, service.dataType]);

  return {
    data,
  };
};
